import { render } from "./productListSkeleton.vue?vue&type=template&id=7eb73a24"
import script from "./productListSkeleton.vue?vue&type=script&lang=js"
export * from "./productListSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__